import module from 'module';

class ClientEnvironmentService {
  constructor(clientEnvironmentCache, popup) {
    this.clientEnvironmentCache = clientEnvironmentCache;
    this.popup = popup;

    this.initialize();
  }

  async initialize() {
    this.clientEnvironment = await this.clientEnvironmentCache.toPromise();
  }

  isNextbank() {
    return 'NEXTBANK' === this.clientEnvironment;
  }

  isVillarica() {
    return 'VILLARICA' === this.clientEnvironment;
  }

  isCBEstrada() {
    return 'CBESTRADA' === this.clientEnvironment;
  }

  showPawnRenewalTicketPopup(currentBranchId, pawnBranchId) {
    if ((currentBranchId !== pawnBranchId) && this.isVillarica()) {
      this.popup({
        header: 'Information',
        text: 'Please print the RA ticket.'
      });
    }
  }
}

module.service('clientEnvironmentService', ClientEnvironmentService);